import { memo } from "react";
import PurchaseSupplierTable from "./PurchaseSupplierTable";
import PurchaseItemsTable from "./PurchaseItemsTable";
import PurchaseTaxNoteTable from "./PurchaseTaxNoteTable";

const PurchaseContent = ({ step = 0 }) => {
  return (
    <>
      {step === 0 && <PurchaseSupplierTable />}

      {step === 1 && <PurchaseTaxNoteTable />}

      {step === 2 && <PurchaseItemsTable />}
    </>
  );
};

export default memo(PurchaseContent);
